/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_CheckpointsInputs */

const en_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkpoints`)
};

const ar_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقاط فحص`)
};

const bn_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চেকপয়েন্ট`)
};

const de_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollpunkte`)
};

const es_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos de control`)
};

const fr_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points de contrôle`)
};

const pt_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos de verificação`)
};

const zh_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查点`)
};

const tr_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol Noktaları`)
};

const ru_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контрольные точки`)
};

const pl_svchip_checkpoints = /** @type {(inputs: Svchip_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkty kontrolne`)
};

/**
* | output |
* | --- |
* | "Checkpoints" |
*
* @param {Svchip_CheckpointsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_checkpoints = /** @type {((inputs?: Svchip_CheckpointsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_CheckpointsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_checkpoints(inputs)
	if (locale === "bn") return bn_svchip_checkpoints(inputs)
	if (locale === "de") return de_svchip_checkpoints(inputs)
	if (locale === "es") return es_svchip_checkpoints(inputs)
	if (locale === "fr") return fr_svchip_checkpoints(inputs)
	if (locale === "pt") return pt_svchip_checkpoints(inputs)
	if (locale === "zh") return zh_svchip_checkpoints(inputs)
	if (locale === "tr") return tr_svchip_checkpoints(inputs)
	if (locale === "ru") return ru_svchip_checkpoints(inputs)
	if (locale === "pl") return pl_svchip_checkpoints(inputs)
	return en_svchip_checkpoints(inputs)
});